import React, { useMemo } from "react";

export default function DeliveryFailuresChart({ data = {} }) {
  // Формируем массив [{reason, count, percent}]
  const topReasons = useMemo(() => {
    const entries = Object.entries(data)
      .map(([reason, count]) => ({ reason, count }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 5);

    const total = entries.reduce((sum, r) => sum + r.count, 0);
    return entries.map((r) => ({
      ...r,
      percent: total ? ((r.count / total) * 100).toFixed(1) : "0.0",
    }));
  }, [data]);

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: 16,
        boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
      }}
    >
      <h3 style={{ marginTop: 0 }}>Причины недоставок</h3>
      <p style={{ color: "#666", marginBottom: 10 }}>
        Топ-5 причин недоставок за выбранный период.
      </p>

      {topReasons.length === 0 ? (
        <p style={{ color: "#999" }}>Нет недоставленных заказов.</p>
      ) : (
        <div style={{ marginTop: 8 }}>
          {topReasons.map((r, i) => (
            <div
              key={r.reason}
              style={{
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: 14,
                  marginBottom: 4,
                }}
              >
                <span>
                  {i + 1}. {r.reason}
                </span>
                <span style={{ color: "#555" }}>
                  {r.count} ({r.percent}%)
                </span>
              </div>
              <div
                style={{
                  height: 8,
                  background: "#eee",
                  borderRadius: 4,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: `${r.percent}%`,
                    background: "#ff6b6b",
                    height: "100%",
                    borderRadius: 4,
                    transition: "width 0.3s",
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
